module.exports = __webpack_public_path__ + "img/header_text@2x.8c4a1880.png";